import config from './routerPageStackConfig'
const history = {
  action: config.pushName
}
export default history
